import { Box } from '@mui/material';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';

import Sidebar from '../../../../components/Sidebar/Sidebar';
import {
  ButtonCollapseStyled,
  ContentWrapStyled,
  LayoutStyled,
  SidebarWrapStyled,
} from './TicketsPageLayout.styled';
import { useTickets } from 'contexts/TicketsContext';
import { DoubleArrowUpIcon } from 'icons';

const TicketsPageLayout: FC = () => {
  /**
   * Hooks
   */
  const { setSidebarIsOpen, isSidebarOpened } = useTickets();

  /**
   * Handlers
   */
  const handleViewSidebar = () => {
    setSidebarIsOpen(!isSidebarOpened);
  };

  return (
    <LayoutStyled>
      <SidebarWrapStyled isOpened={isSidebarOpened}>
        <Sidebar isSidebarOpened={isSidebarOpened} />
        <ButtonCollapseStyled
          size="xs"
          variant="outline"
          className="collapse-sidebar-btn"
          onClick={handleViewSidebar}
          isOpened={isSidebarOpened}
          icon={<DoubleArrowUpIcon />}
          title={isSidebarOpened ? 'Hide sidebar' : 'Show sidebar'}
        >
          Collapse
        </ButtonCollapseStyled>
      </SidebarWrapStyled>
      <ContentWrapStyled isOpened={isSidebarOpened}>
        <Box sx={{ overflowY: 'auto' }}>
          <Outlet />
        </Box>
      </ContentWrapStyled>
    </LayoutStyled>
  );
};

export default TicketsPageLayout;
